export default __webpack_public_path__ + "static/lframe-apply-48502e21cb8960f9d72ca59a5a03fd23.png";